(function () {
  function initSection(root) {
    if (!root || root.dataset.etQuizInit === '1') return;
    root.dataset.etQuizInit = '1';

    var totalSteps = parseInt(root.dataset.totalSteps, 10) || 0;
    var steps = root.querySelectorAll('[data-step]');
    var resultEl = root.querySelector('[data-result]');
    var ctaEl = root.querySelector('[data-cta]');
    var ctaFallbackHref = ctaEl ? ctaEl.getAttribute('href') : '#';

    if (!steps.length) return;

    var currentStep = 1;
    var selected = {}; /* { stepIndex: { optionIndex, url } } */

    function getStepEl(idx) {
      for (var i = 0; i < steps.length; i++) {
        if (parseInt(steps[i].dataset.step, 10) === idx) return steps[i];
      }
      return null;
    }

    function updateNextState(stepEl) {
      if (!stepEl) return;
      var stepIdx = parseInt(stepEl.dataset.step, 10);
      var nextBtn = stepEl.querySelector('[data-next]');
      if (!nextBtn) return;
      if (selected[stepIdx]) {
        nextBtn.classList.remove('is-disabled');
      } else {
        nextBtn.classList.add('is-disabled');
      }
    }

    function showStep(idx) {
      steps.forEach(function (s) {
        var sIdx = parseInt(s.dataset.step, 10);
        if (sIdx === idx) {
          s.hidden = false;
          s.classList.add('is-active');
          updateNextState(s);
        } else {
          s.hidden = true;
          s.classList.remove('is-active');
        }
      });
      if (resultEl) resultEl.hidden = true;
      currentStep = idx;
    }

    function showResult(destinationUrl) {
      steps.forEach(function (s) {
        s.hidden = true;
        s.classList.remove('is-active');
      });
      if (resultEl) {
        resultEl.hidden = false;
        if (ctaEl) {
          ctaEl.href = destinationUrl || ctaFallbackHref || '#';
        }
      }
    }

    function selectOption(stepIdx, optionBtn) {
      var stepEl = getStepEl(stepIdx);
      if (!stepEl) return;
      var options = stepEl.querySelectorAll('[data-option-index]');
      options.forEach(function (o) { o.classList.remove('is-selected'); });
      optionBtn.classList.add('is-selected');
      selected[stepIdx] = {
        optionIndex: parseInt(optionBtn.dataset.optionIndex, 10),
        url: optionBtn.dataset.url || ''
      };
      updateNextState(stepEl);
    }

    /* Bind option clicks */
    root.querySelectorAll('[data-option-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepEl = btn.closest('[data-step]');
        if (!stepEl) return;
        var stepIdx = parseInt(stepEl.dataset.step, 10);
        selectOption(stepIdx, btn);
      });
    });

    /* Bind Next */
    root.querySelectorAll('[data-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepEl = btn.closest('[data-step]');
        if (!stepEl) return;
        var stepIdx = parseInt(stepEl.dataset.step, 10);

        /* Validate that an option is selected */
        if (!selected[stepIdx]) {
          stepEl.classList.add('is-shake');
          setTimeout(function () { stepEl.classList.remove('is-shake'); }, 300);
          return;
        }

        var isFinal = stepEl.dataset.isFinal === 'true';
        if (isFinal) {
          var url = selected[stepIdx].url;
          showResult(url);
        } else {
          showStep(stepIdx + 1);
        }
      });
    });

    /* Bind Previous */
    root.querySelectorAll('[data-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepEl = btn.closest('[data-step]');
        if (!stepEl) return;
        var stepIdx = parseInt(stepEl.dataset.step, 10);
        if (stepIdx > 1) showStep(stepIdx - 1);
      });
    });

    /* Initial state — disable Next on the first (visible) step */
    var firstStep = getStepEl(1);
    if (firstStep) updateNextState(firstStep);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="et-size-quiz"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-section-type="et-size-quiz"]');
    if (root) initSection(root);
  });
})();
